import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from '@angular/material/datepicker';
import {MatError, MatFormField, MatInput, MatLabel, MatSuffix} from '@angular/material/input';
import {TranslatePipe} from '@ngx-translate/core';
import {DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import {YearOnlyDateAdapter} from '../../../entities/consultant/personal-data/year-only-adapter';
import {
  MIN_YEAR_DATE,
  toYearDate,
  YEAR_ONLY_FORMATS
} from '../../../entities/consultant/personal-data/year-only-date';

@Component({
  selector: 'app-year-date-picker',
  imports: [
    FormsModule,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatError,
    MatFormField,
    MatInput,
    MatLabel,
    MatSuffix,
    ReactiveFormsModule,
    TranslatePipe
  ],
  templateUrl: './year-date-picker.component.html',
  styleUrl: './year-date-picker.component.scss',
  standalone: true,
  providers: [
    {provide: DateAdapter, useClass: YearOnlyDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: YEAR_ONLY_FORMATS}
  ]
})
export class YearDatePickerComponent implements OnInit {
  @Input() date: Date | string;
  @Input() label: string;
  // NP20-950: null heisst "kein Jahr" - der Parent muss das leere Feld genauso
  // erfahren wie eine gueltige Jahreszahl.
  @Output() changedYear = new EventEmitter<number | null>();
  yearForm: FormGroup;

  /** NP20-950: frueher als 1900 laesst der Kalender nicht mehr waehlen. */
  readonly minYearDate = MIN_YEAR_DATE;

  constructor(private fb: FormBuilder) {
  }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    // NP20-950: ohne gespeichertes Jahr bleibt das Feld leer, statt ein Invalid
    // Date zu halten, das required fuer eine Eingabe haelt.
    this.yearForm = this.fb.group({
      year: [toYearDate(this.date)]
    });
  }

  setYear(normalizedYear: Date, datepicker: MatDatepicker<Date>) {
    const year = normalizedYear.getFullYear();
    this.yearForm.get('year')?.setValue(new Date(year, 0, 1));
    datepicker.close();
    this.changedYear.emit(year);
  }

  // NP20-950: dateChange feuert erst beim Fokusverlust, deshalb zusaetzlich dateInput.
  // Sonst wird das Formular des Parents beim Tippen erst nach dem Blur aktualisiert.
  emitYear(date: Date | null) {
    // NP20-950: Ein leeres oder unvollstaendiges Feld wurde hier verschluckt.
    // Im Parent blieb dadurch der letzte gueltige Zwischenstand stehen - beim
    // Leeren von "2001" war das die 2001 selbst - und liess sich speichern.
    if (!date || isNaN(date.getTime())) {
      this.changedYear.emit(null);
      return;
    }
    this.changedYear.emit(date.getFullYear());
  }
}
